import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from '../../lazy/lazyConstants';

export default universal(
    universalImport({
        chunkName: () => 'DevToolBarLazy',
        path: () => path.join(__dirname, './DevToolBar'),
        resolve: () => require.resolveWeak('./DevToolBar'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "DevToolBarLazy" */ './DevToolBar')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
